<h4 class="towers-bs__title typography-title flex items-center gap-4">
  <app-game-icon game="Towers"></app-game-icon>
  Place Your Bet
</h4>
@let isGameActive = towersService.currentGame()?.status === 'active';
<div class="towers-bs__inputs">
  <div class="towers-bs--bet-input">
    <app-old-slider
      [(value)]="towersService.amount"
      [disabled]="isGameActive"
      [uiSettings]="{
        thumbSize: '12px',
        trackHeight: '6px',
      }"
    ></app-old-slider>
    <app-input-options
      [(value)]="towersService.amount"
      [icon]="sessionService.balanceIconSrc()"
      [options]="betInputOptions"
      [disabledInput]="isGameActive"
      [disabledOptions]="isGameActive"
      [placeholder]="sessionService.balanceType() + ' value'"
      [settings]="{
      optionType: 'square',
      maskSettings: {
        mask: 'percent.2',
      },
    }"
    />
  </div>
  <div class="towers-bs--bet-buttons">
    @for (item of betButtons; track $index) {
    <button
      class="button button--style-primary button--style-primary-bordered padding-x-8 rounded-4 h-32"
      (click)="item.fn()"
      [disabled]="isGameActive"
    >
      <app-balance-icon
        [balance]="sessionService.balanceType()"
        color="var(--yellow)"
      ></app-balance-icon>
      {{ item.label }}
    </button>
    }
  </div>
  <div class="towers-bs--risk-buttons">
    <button
      [disabled]="isGameActive"
      class="towers-bs__risk-button low"
      [class.active]="towersService.mode().modeName === 'low'"
      (click)="setMode('low')"
    >
      LOW
    </button>
    <button
      [disabled]="isGameActive"
      class="towers-bs__risk-button medium"
      [class.active]="towersService.mode().modeName === 'medium'"
      (click)="setMode('medium')"
    >
      MEDIUM
    </button>
    <button
      [disabled]="isGameActive"
      class="towers-bs__risk-button high"
      [class.active]="towersService.mode().modeName === 'high'"
      (click)="setMode('high')"
    >
      HIGH
    </button>
  </div>
  <button
    class="towers-bs--button"
    [disabled]="isGameActive && towersService.pickIndexes().length === 0"
    (click)="isGameActive ? towersService.cashoutTowers() : handleStartTowers()"
  >
    {{
      isGameActive
        ? "CASH OUT"
        : towersService.currentGame()?.status === "finished"
        ? "PLAY AGAIN"
        : "PLACE BET"
    }}
  </button>
  @if (towersService.currentGame()?.status || towersService.repeat()) {
  <div @fadeInAnimation class="towers-bs--cg">
    <div
      class="towers-bs--cg__processing flex items-center justify-center gap-4"
    >
      <span class="dots-animation">
        {{
          towersService.currentGame()?.status !== "finished"
            ? "Game In Progress"
            : "Results"
        }}
      </span>
    </div>
    <div class="towers-bs--cg__progress">
      <div class="towers-bs--cg__progress-item multiplier">
        <span>
          {{
            towersService.currentMultiplier() | currency : "" : "" : "1.2-2"
          }}x
        </span>
      </div>
      <div class="towers-bs--cg__progress-item score">
        <app-balance-icon
          [balance]="towersService.currentGame()?.balancetype"
          color="var(--yellow)"
        ></app-balance-icon>
        {{
          towersService.currentMultiplier() *
            (towersService.currentGame()?.value ?? towersService.amount())
            | currency : "" : "" : "1.2-2"
        }}
      </div>
    </div>
  </div>
  }
</div>

<div class="towers-bs--bottom">
  <app-fairness-button [href]="'/provably-fair/towers/'"></app-fairness-button>
  <div class="towers-bs--seed">
    <span class="towers-bs--seed__title">Client Seed:</span>
    <span
      class="towers-bs--seed__value"
      (click)="
        clipboardService.copy(
          sessionService.clientSeed()?.seed ?? '',
          'Client Seed copied!'
        )
      "
    >
      {{ sessionService.clientSeed()?.seed }}
    </span>
  </div>
</div>
